/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type TradeDesignManagerModal_user$ref = any;
type TradeOnboardingCoachmarkConditionalLoader_user$ref = any;
export type PdpRespIconBubbleDesignManager_user$ref = any;
export type PdpRespIconBubbleDesignManager_user = {
    readonly tradeFirmDesignManagerProfile: {
        readonly hasAccount: unknown | null;
        readonly accountType: string | null;
    } | null;
    readonly " $fragmentRefs": TradeOnboardingCoachmarkConditionalLoader_user$ref & TradeDesignManagerModal_user$ref;
    readonly " $refType": PdpRespIconBubbleDesignManager_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpRespIconBubbleDesignManager_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "tradeFirmDesignManagerProfile",
            "storageKey": null,
            "args": null,
            "concreteType": "TradeFirmDesignManagerProfileType",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "hasAccount",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "accountType",
                    "args": null,
                    "storageKey": null
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "TradeOnboardingCoachmarkConditionalLoader_user",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "TradeDesignManagerModal_user",
            "args": null
        }
    ]
} as any);
(node as any).hash = '215cd72b6910597d7e81b09498479e77';
export default node;
